import { getCachedObject } from 'data/hooks/objects/objectOperations'

const getObject = (objectId) => {
    if (!objectId) return

    return getCachedObject(objectId)
}

export default getObject
